import { shouldFetchPricingSelector } from '../selectors/cart';
import { fetchPricing } from '../actions/cart';

export default [
  {
    selector: shouldFetchPricingSelector,
    actionCreator: fetchPricing,
  },
];
